export const LOT_STATUS = {
  ACTIVE: 'active',
  RECALLED: 'recalled',
};
